import { createAction } from "redux-actions";

export const getBrands = createAction("GET_BRANDS");
export const setBrands = createAction("SET_BRANDS");
